export default {"src":"/_next/static/media/pink.08bc9dda.svg","height":16,"width":16,"blurWidth":0,"blurHeight":0};